/* 30/09 perf fiche : sur la fiche produit, démarre juste APRÈS le 1er affichage (#almea-pdp-pret) — élément caché, prêt quelques ms après. */
/* Maison Alméa — en-tête : panneau de recherche. 30/09 perf : sorti de sections/z-header-masazen.liquid (fichier mis en cache, async).
   Réglages lus dans window.__mzHdrCfg (posé par la section). Attend son repère #almk-hdrs → démarre au même moment qu'avant. */
(function almBoot(){
  if (document.readyState === 'loading' && (!document.getElementById('almk-hdrs') || (document.getElementById('almea-render-barrier') && !document.getElementById('almea-pdp-pret')))) { setTimeout(almBoot, 20); return; }
  var C = window.__mzHdrCfg || {};

(function() {
  const overlay   = document.getElementById('mzSearchOverlay');
  const input     = document.getElementById('mzSoInput');
  const closeBtn  = document.getElementById('mzSoClose');
  const results   = document.getElementById('mzSoResults');
  const defaults  = document.getElementById('mzSoDefault');
  const openBtns  = document.querySelectorAll('#mzSearchBtn, #mzSearchBtnMobile');

  function openSearch() {
    /* 12/09/2026 perf : les cartes categories de la recherche ne se telechargent qu'a l'ouverture */
    try { overlay.querySelectorAll('img[data-src]').forEach(function(im){ if(im.dataset.srcset) im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset'); }); } catch(e) {}
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    document.getElementById('mzHeader')?.classList.add('mz-header--light-page');
    setTimeout(() => input?.focus(), 150);
  }

  function closeSearch() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    input.value = '';
    results.innerHTML = '';
    results.classList.remove('active');
    defaults.style.display = '';
    const isDark = !!C.isDark;
    if (!isDark) {
      document.getElementById('mzHeader')?.classList.remove('mz-header--light-page');
    }
  }

  openBtns.forEach(btn => btn?.addEventListener('click', openSearch));
  /* 12/09/2026 perf : sur bonne connexion, les cartes de la recherche sont recuperees 5 s apres le chargement */
  try { window.addEventListener('load', () => setTimeout(() => { const c = navigator.connection || {}; if (c.saveData || /2g|3g/.test(c.effectiveType || '')) return; overlay.querySelectorAll('img[data-src]').forEach(im => { if (im.dataset.srcset) im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset'); }); }, 5000)); } catch (e) {}
  closeBtn?.addEventListener('click', closeSearch);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('open')) closeSearch();
  });

  let searchTimer;
  input?.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(searchTimer);
    if (!q) {
      results.innerHTML = '';
      results.classList.remove('active');
      defaults.style.display = '';
      return;
    }
    defaults.style.display = 'none';
    results.classList.add('active');
    results.innerHTML = '<div class="mz-so-results-loading">Recherche en cours…</div>';
    searchTimer = setTimeout(() => fetchResults(q), 280);
  });

  function fetchResults(q) {
    const url1 = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=10';
    const url2 = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    Promise.all([fetch(url1).then(r => r.json()), fetch(url2).then(r => r.json())])
      .then(([data1, data2]) => {
        const seen = new Set();
        const products1 = data1?.resources?.results?.products || [];
        const collections = data1?.resources?.results?.collections || [];
        const products2 = data2?.resources?.results?.products || [];
        const merged = [...products1];
        products1.forEach(p => seen.add(p.handle));
        products2.forEach(p => { if (!seen.has(p.handle)) merged.push(p); seen.add(p.handle); });
        // Fetch descriptions en parallèle (max 8 produits)
        const toFetch = merged.slice(0, 8);
        Promise.all(
          toFetch.map(p =>
            fetch('/products/' + p.handle + '.js')
              .then(r => r.json())
              .then(full => {
                p.description = full.description || '';
                if (full.price && full.price > 0) p.price = full.price;
                if (full.compare_at_price && full.compare_at_price > 0) p.compare_at_price_max = full.compare_at_price;
              })
              .catch(() => {})
          )
        ).then(() => {
          renderResultsFallback({ resources: { results: { products: merged, collections } } }, q);
        });
      })
      .catch(() => {
        results.innerHTML = '<div class="mz-so-results-empty">Une erreur est survenue.</div>';
      });
  }

  function formatPrice(val) {
    if (!val && val !== 0) return '';
    const num = typeof val === 'string' ? parseFloat(val) : val;
    if (isNaN(num)) return '';
    const euros = num / 100;
    return euros.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  function renderResults(data, q) {
    const products = data?.results || data?.products || [];
    if (!products.length) {
      renderResultsFallback(null, q);
      return;
    }
    renderProductGrid(products, q, data?.results_count || products.length);
  }

  function renderResultsFallback(data, q) {
    const products    = data?.resources?.results?.products || [];
    const collections = data?.resources?.results?.collections || [];

    if (!products.length && !collections.length) {
      results.innerHTML = `<div class="mz-so-results-empty" style="padding:20px 60px;">Aucun résultat pour "${q}"</div>`;
      return;
    }

    let html = '';

    if (products.length) {
      html += `<div class="mz-so-gong-header">
        <span class="mz-so-gong-count">${products.length}+ résultats</span>
        <a href="/search?q=${encodeURIComponent(q)}" class="mz-so-gong-seeall">Voir tout →</a>
      </div>`;
      html += '<div class="mz-so-gong-layout">';

      // Sidebar gauche
      html += '<div class="mz-so-gong-sidebar">';
      if (collections.length) {
        html += `<div class="mz-so-gong-filter-title">Catégorie <span>(${collections.length})</span></div>`;
        html += '<div class="mz-so-gong-filter-list">';
        collections.forEach(c => {
          html += `<a href="${c.url}" class="mz-so-gong-filter-item">${c.title}</a>`;
        });
        html += '</div>';
      }
      html += `<a href="/search?q=${encodeURIComponent(q)}" class="mz-so-gong-filter-viewall">Voir tous les résultats →</a>`;
      html += '</div>';

      // Grille produits — style carte comme image de référence
      html += '<div class="mz-so-gong-grid">';
      products.forEach(p => {
        const priceRaw   = p.price;
        const compareRaw = p.compare_at_price_max;
        let priceStr = '', compareStr = '';

        if (priceRaw !== undefined && priceRaw !== null) {
          const priceNum = typeof priceRaw === 'string' ? parseFloat(priceRaw) : priceRaw;
          const priceNumFinal = priceNum > 1000 ? priceNum / 100 : priceNum;
          priceStr = priceNumFinal.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
          if (compareRaw) {
            const compareNum = typeof compareRaw === 'string' ? parseFloat(compareRaw) : compareRaw;
            const compareNumFinal = compareNum > 1000 ? compareNum / 100 : compareNum;
            if (compareNumFinal > priceNumFinal) {
              compareStr = compareNumFinal.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
            }
          }
        }

        let discountBadge = '';
        if (compareStr && priceRaw && compareRaw) {
          const pRaw = typeof priceRaw === 'string' ? parseFloat(priceRaw) : priceRaw;
          const cRaw = typeof compareRaw === 'string' ? parseFloat(compareRaw) : compareRaw;
          const pct = Math.round((1 - pRaw / cRaw) * 100);
          if (pct > 0) discountBadge = `<span class="mz-so-gong-badge mz-so-gong-badge--disc">-${pct}%</span>`;
        }

        const img = p.image || p.featured_image || '';
        const imgSrc = img ? (img.startsWith('//') ? 'https:' + img : img) : '';
        const imgUrl = imgSrc ? (imgSrc.split('?')[0] + '?width=600') : '';

        const desc = p.description
          ? p.description.replace(/<[^>]*>/g, '').trim().substring(0, 100) + '…'
          : '';

        html += `<a href="${p.url}" class="mz-so-gong-card">
          <div class="mz-so-gong-card-img">
            ${discountBadge}
            ${imgUrl ? `<img src="${imgUrl}" alt="${p.title}" loading="lazy">` : '<div class="mz-so-gong-card-placeholder"></div>'}
          </div>
          <div class="mz-so-gong-card-info">
            <div class="mz-so-gong-card-vendor">${p.vendor || ''}</div>
            <div class="mz-so-gong-card-title">${p.title}</div>
            ${desc ? `<div class="mz-so-gong-card-desc">${desc}</div>` : ''}
            <div class="mz-so-gong-card-price">
              <span class="mz-so-gong-price-current ${compareStr ? 'is-sale' : ''}">${priceStr}</span>
              ${compareStr ? `<span class="mz-so-gong-price-compare">${compareStr}</span>` : ''}
            </div>
          </div>
        </a>`;
      });
      html += '</div></div>';
    } else if (collections.length) {
      html += '<div class="mz-so-chips" style="margin-top:10px;padding:0 60px;">';
      collections.forEach(c => {
        html += `<a href="${c.url}" class="mz-so-chip">${c.title}</a>`;
      });
      html += '</div>';
    }

    results.innerHTML = html;
  }

    
  function renderProductGrid(products, q, total) {
    let html = `<div class="mz-so-grid-header">
      <span class="mz-so-section-title" style="margin-bottom:0;">${total} résultat${total > 1 ? 's' : ''}</span>
      <a href="/search?q=${encodeURIComponent(q)}" class="mz-so-grid-seeall">Voir tout →</a>
    </div>`;
    html += '<div class="mz-so-grid">';
    products.forEach(p => {
      const price = formatPrice(p.price);
      const compare = p.compare_at_price && p.compare_at_price > p.price ? formatPrice(p.compare_at_price) : null;
      const imgSrc = p.featured_image?.src || p.images?.[0]?.src || '';
      const imgUrl = imgSrc ? (imgSrc.split('?')[0] + '?width=400') : '';
      html += `<a href="/products/${p.handle}" class="mz-so-grid-item">
        <div class="mz-so-grid-img">
          ${imgUrl ? `<img src="${imgUrl}" alt="${p.title}" loading="lazy">` : '<div class="mz-so-grid-img-placeholder"></div>'}
        </div>
        <div class="mz-so-grid-info">
          <div class="mz-so-grid-title">${p.title}</div>
          <div class="mz-so-grid-price">
            ${compare ? `<span class="mz-so-price-compare">${compare}</span>` : ''}
            <span class="mz-so-price-current ${compare ? 'is-sale' : ''}">${price}</span>
          </div>
        </div>
      </a>`;
    });
    html += '</div>';
    results.innerHTML = html;
  }
})();

})();
